var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsDown = function SvgThumbsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.27 3.904h10.519v12L10.154 22.5l-.846-.846a1.2 1.2 0 0 1-.259-.413 1.3 1.3 0 0 1-.103-.483v-.254l1.062-4.6h-6.7q-.714 0-1.26-.547-.549-.547-.548-1.26V12.48q0-.156.04-.337.04-.18.09-.336l2.866-6.762q.216-.48.721-.811.506-.33 1.052-.331m9.019 1.5h-9.02q-.105 0-.216.058a.37.37 0 0 0-.168.192L3 12.404v1.692a.3.3 0 0 0 .087.221.3.3 0 0 0 .22.087h8.597l-1.254 5.48 4.639-4.618zm1.5 10.5v-1.5H20v-9h-3.212v-1.5H21.5v12z"
  })));
};
export default SvgThumbsDown;